import React, { useState } from "react";
import { Button, Modal, Table, Form } from "react-bootstrap";
import { Formik, Form as FormikForm, Field } from "formik";
import { addUpdateVendor } from "app/services/vendorService";
import { NotificationManager } from "react-notifications";

export default function SupplierJourneyType({
  initialValues,
  setInitialValues,
  show,
  handleClose,
  loadVendorList,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (values) => {
    // debugger;
    // console.log(values);
    setIsLoading(true);
    try {
      const response = await addUpdateVendor(values);
      if (response.status == "Success") {
        NotificationManager.success(response.message);

        handleClose();
      } else {
        NotificationManager.success("Something Went to be Wrong");
      }
    } catch (error) {}

    loadVendorList();
    setIsLoading(false);
  };
  const gatewayFormatter = (cell, row) => {
    return cell == "TRAVELPORT_GAL" ? "TRAVELPORT GAL" : cell;
  };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <div
            style={{
              textTransform: "uppercase",
            }}
          >
            <span
              className="text-primary"
              style={{
                textTransform: "uppercase",
              }}
            >
              {gatewayFormatter(initialValues.supplierName)}
            </span>{" "}
            Journey Type
          </div>
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          ...initialValues,
          domesticOneway: initialValues?.domesticOneway,
          internationalOneway: initialValues?.internationalOneway,
          domesticReturn: initialValues?.domesticReturn,
          internationalReturn: initialValues?.internationalReturn,
        }}
        // onSubmit={
        //   (values) => {
        //   setInitialValues((prev) => ({ ...prev, ...values }));
        //   handleClose();
        // }}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange }) => (
          <FormikForm>
            <Modal.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        JOURNEY TYPE
                      </div>
                    </th>
                    <th>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        ONEWAY
                      </div>
                    </th>
                    <th>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        RETURN
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        DOMESTIC
                      </div>
                    </td>
                    <td>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          name="domesticOneway"
                          checked={values.domesticOneway}
                          onChange={handleChange}
                        />
                      </div>
                    </td>
                    <td>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          name="domesticReturn"
                          checked={values.domesticReturn}
                          onChange={handleChange}
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        INTERNATIONAL
                      </div>
                    </td>
                    <td>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          name="internationalOneway"
                          checked={values.internationalOneway}
                          onChange={handleChange}
                        />
                      </div>
                    </td>
                    <td>
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          name="internationalReturn"
                          checked={values.internationalReturn}
                          onChange={handleChange}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              {isLoading ? (
                <Button variant="primary" disabled={true}>
                  Saving...
                </Button>
              ) : (
                <Button type="submit" variant="primary">
                  Save Changes
                </Button>
              )}
            </Modal.Footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}
